import { createReducer, on } from "@ngrx/store";
import { Division } from "../../models/division";
import { findDivisionAct, loadDivisionByIdAct, saveSuccessDivisionAct, setViolationsDivisionAct, updateSuccessDivisionAct } from "./division.actions";

const division: Division = new Division();

export const divisionReducer = createReducer(
    {
        division,
        violations: {},
        loading: true
    },
    on(findDivisionAct, (state, { id }) => ({
        division: state.division,
        violations: state.violations,
        loading: true
    })),
    on(loadDivisionByIdAct, (state, { division }) => ({
        division: division,
        violations: state.violations,
        loading: false
    })),
    on(saveSuccessDivisionAct, (state, { divisionNew }) => ({
        division: { ...divisionNew },
        violations: {},
        loading: state.loading
    })),
    on(updateSuccessDivisionAct, (state, { divisionUpdated}) => ({
        division: { ...divisionUpdated },
        violations: {},
        loading: state.loading
    })),
    on(setViolationsDivisionAct, (state, { divisionForm, violations }) => ({
        division: { ...divisionForm },
        violations: {...violations},
        loading: false //state.loading
    }))
    /*CRUD CATALOG DIVISIONS END*/
)